export default {
  // 页面标题
  pageTitle: "AI模型",

  // 按钮
  addModel: "添加模型",
  reset: "重置",
  query: "查询",
  download: "下载",

  // 搜索区域
  selectCaseName: "请选择案件名称",
  inputAddress: "请输入地址",

  // 统计信息
  totalCount: "共计",
  totalData: "条数据",
  selected: "已选择",
  items: "项",

  // 加载提示
  loading: "拼命加载中",

  // 表格列名
  serialNumber: "序号",
  caseName: "案件名称",
  blockchain: "公链",
  address: "地址",
  model: "模型",
  creator: "创建人",
  time: "时间",
  status: "状态",
  operation: "操作",

  // 状态
  verified: "已验证",
  toBeVerified: "待验证",

  // 操作按钮
  view: "查看",
  normalSurvey: "普通调证",
  keySurvey: "重点调证",
  delete: "删除",

  // 对话框
  verificationResult: "验证结果",
  tip: "提示",
  confirmDownload: "是否下载已选中的模型验证结果？",
  yes: "是",
  no: "否",
  confirmDeleteAddress: "是否要删除此条地址?",
  confirm: "确定",
  cancel: "取消",

  // 消息提示
  copySuccess: "复制成功",
  deleteSuccess: "删除成功",
  deleteCancel: "已取消删除",

  // 新手引导
  guideStep1: "点击添加模型验证",
  guideStep2: "模型验证列表，点击【查看结果】可以查看涉案地址手续费来源。",
};
